<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>History Data Gadai</h5>
            </template>
            <div class="form-content-wrapper mb-4">
                <b-form-group>
                    <b-form-select v-model="input.historyGadai" name="historyGadai" :options="historyGadaiOption" value-field="id" text-field="name">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>History</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </div>
            <p v-if="historyGadaiOption.length == 0">Tidak ada perubahan untuk data gadai ini</p>
            <div v-if="input.historyGadai != null && dataGadai != null">
                
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">KETERANGAN</h6>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Dibuat pada</b-col>
                        <b-col v-if="dataGadai.createdAt != null">{{ $helper.changeDateFormat(dataGadai.createdAt )}} {{ $helper.changeDateFormatGetHour(dataGadai.processedAt )}}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Dibuat oleh</b-col>
                        <b-col v-if="dataGadai.createdBy != null">{{ dataGadai.createdBy }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Diproses pada</b-col>
                        <b-col v-if="dataGadai.processedAt != null">{{ $helper.changeDateFormat(dataGadai.processedAt )}} {{ $helper.changeDateFormatGetHour(dataGadai.processedAt )}}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Diproses oleh</b-col>
                        <b-col v-if="dataGadai.processedBy != null">{{ dataGadai.processedBy }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Keterangan Revisi</b-col>
                        <b-col v-if="dataGadai.keteranganRevisi != null">{{ dataGadai.keteranganRevisi }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Keterangan Approval</b-col>
                        <b-col v-if="dataGadai.keteranganApproval != null">{{ dataGadai.keteranganApproval }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>
                <div v-if="dataGadai.detail.kendaraan == null" class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA BARANG</h6>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jenis Barang</b-col>
                        <b-col v-if="dataGadai.detail.jenis != null">{{ dataGadai.detail.jenis.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Merk Barang</b-col>
                        <b-col v-if="dataGadai.detail.merk != null">{{ dataGadai.detail.merk.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Tipe Barang</b-col>
                        <b-col v-if="dataGadai.detail.tipe != null">{{ dataGadai.detail.tipe.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Spek</b-col>
                        <b-col>
                            <div v-if="dataGadai.detail && dataGadai.detail.spek == 2">RESMI</div>
                            <div v-else-if="dataGadai.detail && dataGadai.detail.spek == 5">LN</div>
                            <div v-else>-</div>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Model</b-col>
                        <b-col v-if="dataGadai.detail.tipe && dataGadai.detail.tipe.noModel">
                            {{ (dataGadai.detail.tipe && dataGadai.detail.tipe.noModel) ?dataGadai.detail.tipe.noModel :'-' }}
                        </b-col>
                        <b-col v-else>
                            {{ (dataGadai.detail.modelNumber) ?((dataGadai.detail.modelNumber == 'Lainnya') ?dataGadai.detail.modelNumberLainnya :dataGadai.detail.modelNumber) :'-' }}
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Tahun</b-col>
                        <b-col v-if="dataGadai.detail.tahun != null">{{ dataGadai.detail.tahun }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row v-if="dataGadai.detail.kendaraan == null" class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Imei/ SN</b-col>
                        <b-col v-if="dataGadai.detail.noImei != null">{{ dataGadai.detail.noImei }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Password</b-col>
                        <b-col v-if="dataGadai.detail.password != null">{{ dataGadai.detail.password }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Grade Barang</b-col>
                        <b-col v-if="dataGadai.detail.gradeKondisi != null">{{ dataGadai.detail.gradeKondisi.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Warna</b-col>
                        <b-col v-if="dataGadai.detail.warna != null">{{ dataGadai.detail.warna.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kelengkapan Barang</b-col>
                        <b-col v-if="dataGadai.detail.kelengkapan.length >= 1">
                            <ul class="list-circle-wrapper">
                                <li v-for="item in dataGadai.detail.kelengkapan"  v-bind:key="item">
                                    {{ item }}
                                </li>
                            </ul>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Spesifikasi Barang</b-col>
                        <b-col v-if="dataGadai.detail.spesifikasi.length >= 1">
                            <ul class="list-circle-wrapper">
                                <li v-for="(item, idx) in dataGadai.detail.spesifikasi"  v-bind:key="idx">
                                    {{ item.name }}
                                </li>
                            </ul>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kondisi/Kerusakan/Keterangan Lainnya</b-col>
                        <b-col v-if="$helper.isNotNullAndNotEmpty(dataGadai.detail.keterangan)">{{ dataGadai.detail.keterangan }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>

                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Foto</b-col>
                        <b-col v-if="$helper.isNotNullAndNotEmpty(dataGadai.foto)">
                            <span class="mr-1" v-for="(item, idx) in dataGadai.foto"  v-bind:key="idx">
                                <a v-bind:href="item" target="_blank">
                                    <img width="150px" :src="item" alt="Foto Pendukung 3">
                                </a>
                            </span>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>
                <div v-if="dataGadai.detail.kendaraan != null" class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA KENDARAAN</h6>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Tipe Pinjaman</b-col>
                        <b-col v-if="dataGadai.detail.withKendaraan == true">Kendaraan + BPKB</b-col>
                        <b-col v-else>BPKB Saja</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jenis Kendaraan</b-col>
                        <b-col v-if="dataGadai.detail.jenis != null">{{ dataGadai.detail.jenis.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Polisi</b-col>
                        <b-col v-if="dataGadai.detail.kendaraan.noPolisi != null">{{ dataGadai.detail.kendaraan.noPolisi }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Merk</b-col>
                        <b-col v-if="dataGadai.detail.merk != null">{{ dataGadai.detail.merk.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Tipe</b-col>
                        <b-col v-if="dataGadai.detail.tipe != null">{{ dataGadai.detail.tipe.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Tahun</b-col>
                        <b-col v-if="dataGadai.detail.tahun != null">{{ dataGadai.detail.tahun }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kondisi</b-col>
                        <b-col v-if="dataGadai.detail.gradeKondisi != null">{{ dataGadai.detail.gradeKondisi.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Warna</b-col>
                        <b-col v-if="dataGadai.detail.warna != null">{{ dataGadai.detail.warna.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kelengkapan Barang</b-col>
                        <b-col v-if="dataGadai.detail.kelengkapan.length >= 1">
                            <ul class="list-circle-wrapper">
                                <li v-for="item in dataGadai.detail.kelengkapan"  v-bind:key="item">
                                    {{ item }}
                                </li>
                            </ul>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Status</b-col>
                        <b-col v-if="dataGadai.detail.kendaraan.status != null">{{ dataGadai.detail.kendaraan.status }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Spesifikasi Barang</b-col>
                        <b-col v-if="dataGadai.detail.spesifikasi.length >= 1">
                            <ul class="list-circle-wrapper">
                                <li v-for="(item, idx) in dataGadai.detail.spesifikasi"  v-bind:key="idx">
                                    {{ item.name }}
                                </li>
                            </ul>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kondisi/Kerusakan/Keterangan Lainnya</b-col>
                        <b-col v-if="dataGadai.detail.keterangan != null">{{ dataGadai.detail.keterangan }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Foto</b-col>
                        <b-col v-if="$helper.isNotNullAndNotEmpty(dataGadai.foto)">
                            <span class="mr-1" v-for="(item, idx) in dataGadai.foto"  v-bind:key="idx">
                                <a v-bind:href="item" target="_blank">
                                    <img width="150px" :src="item" alt="Foto Pendukung 3">
                                </a>
                            </span>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'history-data-gadai',
    data(){
        return{
            id: null,
            initStatus: 0,
            isBusy: true,
            input:{
                historyGadai: null
            },
            historyGadaiOption : [],
            dataGadai: null,
        }
    }, 
    watch: {

        'input.historyGadai': function(newVal) {

            if(newVal != null){
                this.$axios.get(`gadai/detail-revisi/${newVal}`).then(response => {
                    this.dataGadai = response.data
                })
            }

        },
    },
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            
            this.id = this.$route.params.id
            let getHistoryOption = this.$axios.get(`gadai/daftar-revisi/${this.id}`).then(response => {
                
                let responseGadai = response.data
                for (let y=0; y< responseGadai.length; y++){
                    let dataListHistory = {}
                    dataListHistory.id = responseGadai[y].id
                    if(responseGadai[y].name == '0'){
                        dataListHistory.name = 'Original'
                    }else{
                        dataListHistory.name = 'Revisi ke-'+responseGadai[y].name
                    }
                    this.historyGadaiOption.push(dataListHistory)
                }

            })

            Promise.all([getHistoryOption]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

    },

    created(){
        this.init()
    }
}
</script>
